import LanguageManager from '../language_manager/language_manager';
import Logger from '../../util/logger_utils';
import DomUtils from '../../util/dom_utils';

window.queued_timers = [];

function PauseScreen(emitter) {
    this.timer = false;
    this.active = false;
    this.emitter = emitter;
}

PauseScreen.prototype.show = function(options, onResume) {
    var that = this;

    // Reset to default values
    this.hide();
    this.active = true;
    this.timer = setTimeout(function() {
        if (!that.active) return;
        options = addLayoutTranslations(options);
        that.pauseScreenElement = getPauseScreenElement(options, onResume);
        that.hideResume();
        DomUtils.waitForElement('class', 'bitdash-ctrl-w', function(success, element) {
            if (success) {
                element.insertBefore(that.pauseScreenElement, element.firstChild);
                that.emitter.emit('menu-shown', 'pause-screen');
            } else {
                Logger.warn('PauseScreen could not be attached to player because it could not find the element!');
            }
        });
    }, 30000);

    window.queued_timers.push(this.timer);
};

PauseScreen.prototype.hide = function() {
    this.active = false;
    var elements = document.querySelectorAll('.player-modal--pause');
    const timer = this.timer;
    if (timer) clearTimeout(timer);
    if (elements) {
        Array.from(elements).map(x => x.parentNode.removeChild(x));
    } 
};

PauseScreen.prototype.hideResume = function() {
    this.active = false;
    var elements = document.querySelectorAll('.player-modal--resume');
    if (this.timer) clearTimeout(this.timer);
    if (elements) {
        Array.from(elements).map(x => x.parentNode.removeChild(x));
    } 
};

function getPauseScreenElement(options, onResume) {
    var pauseScreenElement = DomUtils.createElementFromString(require('./pause_screen.hbs')(options));
    pauseScreenElement.onclick = onResume;
    return pauseScreenElement;
}

function getResumeScreenElement(onResume) {
    var resumeScreenElem = DomUtils.createElementFromString(require('./resume_screen.hbs')());
    resumeScreenElem.onclick = function(event) {
        this.classList.remove('is-shown');
        this.style.display = 'none';
        onResume(event);
    };
    return resumeScreenElem;
}

function addLayoutTranslations(options) {
    options = options || {};
    options.youreWatching = LanguageManager.get('youre_watching');
    options.continueWatching = LanguageManager.get('continue_watching');
    options.season = LanguageManager.get('season');
    options.episode = LanguageManager.get('episode');
    return options;
}

PauseScreen.prototype.showResumeLayout = function(onResume) {
    var that = this;

    // Reset to default values
    this.hide();
    this.active = true;
    this.timer = setTimeout(function() {
        that.resumeScreenElem = getResumeScreenElement(onResume);
        that.resumeScreenElem.classList.add('is-shown');
        DomUtils.waitForElement('class', 'bitdash-ctrl-w', function(success, element) {
            if (success) {
                element.insertBefore(that.resumeScreenElem, element.firstChild);
                that.emitter.emit('menu-shown', 'resume-screen');
            } else {
                Logger.warn('ResumeScreen could not be attached to player because it could not find the element!');
            }
        });
    }, 300);
};

module.exports = PauseScreen;



// WEBPACK FOOTER //
// ./src/modules/pause_screen/pause_screen.js